import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as FavoriteOccupationsFeatureState from './favorite-occupations.state';

// FAVORITE OCCUPATION STATE SLICE
export const selectFavoriteOccupationState =
  createFeatureSelector<FavoriteOccupationsFeatureState.FavoriteOccupationsState>(
    FavoriteOccupationsFeatureState.favoriteOccupationsFeatureKey
  );

// RETRIEVE LIST OF OCCUPATIONS
export const selectFavoriteOccupations = createSelector(
  selectFavoriteOccupationState,
  FavoriteOccupationsFeatureState.selectAll
);

// RETRIEVE FAVORITE OCCUPAIONS COUNT
export const selectFavoriteOccupationCount = createSelector(
  selectFavoriteOccupationState,
  FavoriteOccupationsFeatureState.selectTotal
);

// IS FAVORITE OCCUPATIONS AT MAX COUNT
export const selectIsFavoriteOccupationsAtMaxCount = createSelector(
  selectFavoriteOccupationCount,
  (count) => count >= 3
);

export const selectIsOccupationInFavorites = (onetCode: string, jobId = 0) =>
  createSelector(selectFavoriteOccupationState, (state) =>
    state.ids && onetCode
      ? (<string[]>state.ids).includes(`${onetCode}_${jobId ?? 0}`)
      : false
  );
